// Replace Gravity Forms input submit with button element
jQuery(document).ready(function ($) {
  
  // Function to replace input with button
  function replaceSubmitWithButton() {
    // Find all Gravity Forms submit inputs
    const submitInputs = document.querySelectorAll('.gform_button[type="submit"]');
    
    submitInputs.forEach((input) => {
      // Get the form element
      const form = input.closest('form');
      if (!form) return;
      
      // Create new button element
      const button = document.createElement('button');
      
      // Copy attributes
      button.type = 'submit';
      button.className = input.className;
      button.id = input.id;
      button.name = input.name;
      button.value = input.value;
      
      // Copy text content from input value
      button.textContent = input.value;
      
      // Copy any data attributes
      Array.from(input.attributes).forEach(attr => {
        if (attr.name.startsWith('data-')) {
          button.setAttribute(attr.name, attr.value);
        }
      });
      
      // Replace input with button
      input.parentNode.replaceChild(button, input);
      
      // Maintain form submission functionality
      button.addEventListener('click', function(e) {
        // Let the form handle validation naturally
        // The button type="submit" will trigger form submission
      });
    });
  }
  
  // Run on page load
  replaceSubmitWithButton();
  
  // Re-run when Gravity Forms renders (for AJAX forms)
  $(document).on('gform_post_render', function() {
    replaceSubmitWithButton();
  });
  
});

